const messages = {
  en: {
    "card-description-bold": "Ready to simplify your bookkeeping?",
    "card-description":
      "Connect Moneris with QuickBooks Online in just a few steps and make managing your sales and financial data easier—without extra manual work.",
    "card-button": "Get started",
    "card-title": "Quickbooks Online",
  },
  fr: {
    "card-description-bold": "Prêt à simplifier votre comptabilité ?",
    "card-description":
      "Connectez Moneris à QuickBooks Online en quelques étapes et facilitez la gestion de vos ventes et de vos données financières — sans travail manuel supplémentaire.",
    "card-button": "Commencer",
    "card-title": "QuickBooks Online",
  },
};

export default messages;

